import React, { useEffect, useState } from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { WHATSAPP_URL } from '../data/content';
export function WhatsAppFab() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" aria-label="Escribir a Lussonovo por WhatsApp" className={`fixed bottom-6 right-6 z-50 inline-flex items-center gap-2.5 rounded-full bg-ink px-5 py-4 text-[12.5px] font-medium tracking-wide text-cream shadow-lift transition-[opacity,transform,background-color] duration-300 ease-premium hover:bg-walnut ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0'}`} data-id="element-384" data-mp="3kf4qlfi27a5i">
      <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-385" data-mp="36jarfo737z5l" />
      <span className="hidden sm:inline" data-id="element-386" data-mp="2e24xilxpzsp1">Escríbenos por WhatsApp</span>
    </a>;
}